import ACTIONS from "store/actionTypes";

export const startLoading = () => ({
  type: ACTIONS.LOADING_START,
});

export const finishLoading = () => ({
  type: ACTIONS.LOADING_FINISH,
});
